<div class="dropdown" *ngIf="!isLoggedOut">
  <div class="dropdown-header" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="dropdown-heading-icon" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon *ngIf="!profilePicture || profilePicture.length == 0" [icIcon]="icPerson">
        </mat-icon>
        <img @scaleIn class="avatar h-15 w-18 flex-none align-start hidden sm:block border-3 border-white"
          [src]="profilePicture" *ngIf="profilePicture" onError="this.src='assets/default/Custom/no-image-available.svg'">
      </div>
      <div class="dropdown-heading">{{name}}</div>
    </div>

    <!-- <button [matMenuTriggerFor]="settingsMenu" mat-icon-button matTooltip="Settings" matTooltipPosition="before"
      type="button">
      <mat-icon [icIcon]="icSettings" class="notifications-header-icon"></mat-icon>
    </button> -->
  </div>

  <div class="dropdown-content">
    <div *ngIf="showOrganizationControls" class="organization-context-panel">
      <div class="organization-context-copy">
        <span>Organization</span>
        <strong>{{ activeOrganizationName || 'Current organization' }}</strong>
        <small *ngIf="homeOrganizationName">Home: {{ homeOrganizationName }}</small>
      </div>
      <button
        (click)="setTenantBarVisibility(!tenantBarVisible)"
        class="organization-context-toggle"
        mat-button
        type="button">
        {{ tenantBarVisible ? 'Hide organization bar' : 'Show organization bar' }}
      </button>
      <a
        (click)="close()"
        [routerLink]="organizationSettingsRoute"
        class="organization-context-toggle"
        mat-button>
        Organization settings
      </a>
      <a
        (click)="close()"
        [routerLink]="['/platform-settings/audit']"
        class="organization-context-toggle"
        mat-button>
        Audit trail
      </a>
      <a
        (click)="close()"
        [routerLink]="['/platform-settings/worker-nodes']"
        class="organization-context-toggle"
        mat-button>
        Worker nodes
      </a>
    </div>

    <a (click)="close()" *ngFor="let item of items; trackBy: trackById" [routerLink]="item.route" class="notification"
      fxLayout="row" fxLayoutAlign="start center" matRipple>
      <mat-icon [icIcon]="item.icon" [ngClass]="item.colorClass" class="notification-icon" fxFlex="none"></mat-icon>
      <div fxFlex="auto">
        <div class="notification-label">{{ item.label }}</div>
        <div class="notification-description">{{ item.description }}</div>
      </div>
      <mat-icon [icIcon]="icChevronRight" class="notification-chevron" fxFlex="none"></mat-icon>
    </a>
    <a (click)="close(); changePassword()" class="notification" fxLayout="row" fxLayoutAlign="start center" matRipple>
      <mat-icon [icIcon]="icLock" class="notification-icon bg-primary-light text-primary" fxFlex="none"></mat-icon>
      <div fxFlex="auto">
        <div class="notification-label">Change Password</div>
        <div class="notification-description">Change Password</div>
      </div>
      <mat-icon [icIcon]="icChevronRight" class="notification-chevron" fxFlex="none"></mat-icon>
    </a>
    <button (click)="openSyncStatus($event)" class="notification sync-status-link" fxLayout="row"
      fxLayoutAlign="start center" matRipple type="button">
      <mat-icon [icIcon]="icStorage" class="notification-icon bg-primary-light text-primary" fxFlex="none"></mat-icon>
      <div class="notification-copy">
        <div class="notification-label">Local data &amp; sync</div>
        <div class="notification-description">Cache size and table sync status</div>
      </div>
      <mat-icon [icIcon]="icChevronRight" class="notification-chevron" fxFlex="none"></mat-icon>
    </button>
  </div>

  <div class="dropdown-footer" fxLayout="row" fxLayoutAlign="end">
    <button (click)="logout($event)" color="primary" mat-button type="button">LOGOUT</button>
  </div>
</div>

<mat-menu #statusMenu="matMenu" xPosition="before" yPosition="below">
</mat-menu>
